import { Controller } from "@hotwired/stimulus";
import { FetchRequest } from "@rails/request.js";

// Connects to data-controller="integration--sortablejs"
export default class extends Controller {
  static values = {
    resourceName: String,
    paramName: {
      type: String,
      default: "position",
    },
    groupName: {
      type: String,
      default: undefined,
    },
    responseKind: {
      type: String,
      default: "html",
    },
    animation: Number,
    handle: String,
    method: {
      type: String,
      default: "patch",
    },
  };

  initialize() {
    this.onUpdate = this.onUpdate.bind(this);
  }

  async connect() {
    const token = (this.connectToken = {});
    const { default: Sortable } = await import("sortablejs");
    if (this.connectToken !== token) return;

    this.sortable = new Sortable(this.element, {
      ...this.options,
    });
  }

  disconnect() {
    this.connectToken = null;
  }

  async onUpdate({ item, newIndex }) {
    if (!item.dataset.sortablejsUpdateUrl) return;

    const param = this.resourceNameValue
      ? `${this.resourceNameValue}[${this.paramNameValue}]`
      : this.paramNameValue;

    const data = new FormData();

    data.append(param, newIndex + 1);

    const request = new FetchRequest(
      this.methodValue,
      item.dataset.sortablejsUpdateUrl,
      {
        body: data,
        responseKind: this.responseKindValue,
      },
    );

    return await request.perform();
  }

  get options() {
    return {
      onUpdate: this.onUpdate,
      animation: this.animationValue || 150,
      handle: this.handleValue || undefined,
      group: this.groupName || undefined,
    };
  }
}
